import { api_GET_Unauthorize } from './_api';

const geradoresCategoria_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`GeradoresCategoria/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListAtivos: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`GeradoresCategoria/GetListAtivos`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default geradoresCategoria_api;
